import { methods } from './payments'

export default {
  title: 'Recurring payments',

  titles: {
    create: 'Create recurring payment',
    payments: 'Payment history',
    remove: 'Deletion confirmation',
    unlock: 'Unlock confirmation',

    empty: {
      title: 'No recurring payments created',
      sub: 'Create a new recurring payment using the button below'
    }
  },

  methods,

  types: {
    threshold: 'By threshold',
    frequency: 'Periodically',
    description: {
      threshold: 'Payment when the threshold is reached',
      frequency: 'Payment once per period'
    }
  },

  statuses: {
    init: 'Initialized',
    ready: 'Running',
    error: 'Error',
    pause: 'Paused',
    block: 'Blocked'
  },

  labels: {
    method: 'Payment method',
    amount: 'Amount',
    type: 'Payment type',
    status: 'Payment status',
    threshold: 'Top-up threshold',
    frequency: 'Repeat frequency',
    owner: 'Owner'
  },

  contents: {
    threshold: 'When the threshold {threshold} is reached',
    frequency: '{frequency}',
    remove: 'Confirm deletion of recurring payment',
    unlock: 'Confirm unlock of recurring payment',

    confirm: {
      pause: 'You are about to pause the recurring payment.<br>This will disable the recurring payment and prevent automatic debits based on configured thresholds or schedule.<br><strong class="mt-2">Are you sure you want to continue?<strong>',
      resume: 'You are about to resume the recurring payment.<br>This will allow the system to automatically debit funds based on configured thresholds or schedule.<br><strong class="mt-2">Are you sure you want to continue?<strong>'
    }
  },

  hints: {
    method: 'Select the payment method that will be used for future payments',
    amount: 'Enter an amount in rubles greater than zero',
    type: 'Select how the payment should repeat',
    threshold: 'Only whole numbers are allowed.',
    frequency: 'How often funds should be debited',
    redirect: 'After clicking on the "Create" button, you will be redirected to the payment page.',
    notFound: 'No recurring payments found',
    owner: 'Payment owner',

    statuses: {
      init: 'The recurring payment must be confirmed',
      ready: 'The recurring payment is active',
      pause: 'The recurring payment is paused',
      error: 'The recurring payment ended with an error',
      block: 'The recurring payment is blocked'
    },

    types: {
      threshold: 'Payment by threshold',
      frequency: 'Payment by time'
    },

    description: {
      amount: 'The default payment amount equals the threshold.'
    }
  },

  tooltips: {
    debit: '{amount} will be debited.',
    payments: 'Payment history',
    pause: 'Pause',
    continue: 'Resume',
    approve: 'Confirm payment',
    repeat: 'Repeat payment confirmation'
  },

  buttons: {
    add: 'Add recurring payment',
    repeat: 'Repeat payment',
    resume: 'Resume',
    pause: 'Pause',
    payments: 'Payment history',
    confirm: 'Confirm'
  },

  links: {
    confirm: 'Confirm'
  },

  snackbars: {
    created: 'Recurring payment created',
    updated: 'Recurring payment updated',
    removed: 'Recurring payment removed'
  },

  errors: {
    amount: {
      required: 'Amount is required',
      min: 'Amount cannot be equal to or less than zero',
      threshold: 'Amount cannot be less than the threshold'
    },

    threshold: {
      required: 'Threshold is required',
      min: 'Threshold cannot be equal to or less than zero'
    }
  }
}

